var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullhorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 3.71992V56.2799C72.0025 56.9768 71.8084 57.6603 71.4399 58.2519C71.0714 58.8434 70.5435 59.319 69.9169 59.6239C69.2902 59.9289 68.5903 60.0509 67.8974 59.9759C67.2045 59.9009 66.5469 59.6319 66 59.1999L61.88 55.8799C59.7661 54.1721 57.4566 52.7219 55 51.5599C54.0223 51.0828 53.021 50.6555 52 50.2799V9.71992C53.021 9.34429 54.0223 8.91708 55 8.43992C57.4566 7.27791 59.7661 5.82772 61.88 4.11992L66 0.799919C66.5469 0.367916 67.2045 0.0989604 67.8974 0.0239567C68.5903 -0.0510469 69.2902 0.0709445 69.9169 0.375913C70.5435 0.680882 71.0714 1.15645 71.4399 1.74799C71.8084 2.33952 72.0025 3.02301 72 3.71992Z",
    fill: "#5A57F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 10.6797C45.8625 11.5603 42.6187 12.0045 39.36 11.9997H18C13.2261 11.9997 8.64773 13.8962 5.27208 17.2718C1.89642 20.6475 0 25.2258 0 29.9997C0 34.7736 1.89642 39.352 5.27208 42.7276C8.64773 46.1033 13.2261 47.9997 18 47.9997L27.788 67.5757C28.4522 68.905 29.4736 70.023 30.7375 70.8044C32.0014 71.5858 33.458 71.9997 34.944 71.9997H40L36 47.9997H39.36C42.6187 47.995 45.8625 48.4392 49 49.3197C50 49.5997 51 49.9197 52 50.2797V9.71973C51 10.0797 50 10.3997 49 10.6797Z",
    fill: "#5A57F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhorn);
export default __webpack_public_path__ + "static/media/Bullhorn.f67ae7db04c2f90afaef11c012ab4956.svg";
export { ForwardRef as ReactComponent };